import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { CustomMessagesService } from '@core/errors/custom-messages.service';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { sentry } from 'sentry';
import { CompanyRankingService } from '../../../services/company-ranking.service';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';

@Component({
  selector: 'app-dialog-confirm-delete-criterias-group',
  templateUrl: './dialog-confirm-delete-criterias-group.component.html',
  styleUrls: ['./dialog-confirm-delete-criterias-group.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DialogConfirmDeleteCriteriasGroupComponent {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly customMessageService: CustomMessagesService,
    private readonly companyRankingService: CompanyRankingService,
    private readonly fuseTranslationLoaderService: FuseTranslationLoaderService,
    public readonly matDialogRef: MatDialogRef<DialogConfirmDeleteCriteriasGroupComponent>
  ) {
    this.fuseTranslationLoaderService.loadJsonTranslations({ english, portuguese, spanish });
  }

  public async deleteCriteriaGroup(): Promise<void> {
    const { id } = this.data;
    try {
      await this.companyRankingService.deleteCriteriasGroupById(id);
      this.customMessageService.success('DIALOG_CONFIRM_DELETE_CRITERIAS_GROUP.SUCCESS');
    }
    catch (err) {
      this.customMessageService.error('DIALOG_CONFIRM_DELETE_CRITERIAS_GROUP.ERROR');
      sentry.captureException(err);
    }
    finally {
      this.matDialogRef.close(true);
    }
  }
}
